import React from 'react';
import { EOrderTab } from '../../../../store/ducks/long-steel-orders/types';
import { SideSheet } from '@gerdau/hefesto-mais-web';

import {
  Container,
  DownloadText,
  HeaderContainer,
  ProductTable,
  SectionContainer,
  SectionContent,
  SectionWrapper,
  SideSheetContainer,
  Text,
  TextTable,
  Title
} from './styles';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import DeliveryStatusColumn from '../OrdersTable/DeliveryStatusColumn';
import {
  loadNewNFFile,
  loadNewQCFile,
  loadNewShippingNoteFile
} from '../../../../store/ducks/new-long-steel-orders/actions';
import { Billing } from '../../../../store/ducks/new-long-steel-orders/types';
// import { OrderDownloadBulk } from './OrderDownloadBulk';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import moment from 'moment';

export const OrderDownload = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const hasDownload = params.has('downloads');
  // const hasBulk = params.get('downloads') === 'bulk';

  if (!hasDownload) {
    return null;
  }

  const data =
    useSelector(
      (state: ApplicationState) =>
        state.newLongSteelOrders.updateItems.downloadsItemsSelected
    ) ?? [];

  if (!data) {
    return null;
  }

  const ordersState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders
  );

  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );

  const order = data[0];

  const history = useHistory();
  const dispatch = useDispatch();

  const handleClose = () => {
    return history.push(history.location.pathname);
  };

  const downloadNFE = (danfeNumber?: string) => {
    if (!danfeNumber) {
      const billingsFromBilling = order?.billing?.filter(
        (b: Billing) => b.canDownloadNF && !!b.danfeNumber
      );

      const billings: Billing[] = billingsFromBilling?.length
        ? billingsFromBilling
        : order?.danfeNumber
        ? ([
            {
              danfeNumber: order.danfeNumber,
              invoiceNumber: order.invoiceNumber
            }
          ] as unknown as Billing[])
        : [];

      dispatch(loadNewNFFile({ billings }));

      dispatch(
        sendTagging({
          event: 'baixar_todos_nota_fiscal',
          pedido_id: order.customerOrder,
          screenName: 'LG:MeusPedidos',
          itemDescription: 'meus_pedidos_acosLongos',
          estado_emissor:
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.states.join(', '),
          emissor_pedido: customersState.customers
            .filter((item) =>
              ordersState[
                ordersState.tableType || EOrderTab.OPEN
              ].initialInputValues.emitterIds.includes(item.customerId)
            )
            .map((item) => item.name)
            .join(', '),
          data_inicio: moment(
            ordersState[ordersState.tableType || EOrderTab.OPEN]
              .initialInputValues.startDate
          ).format('DD/MM/YYYY'),
          data_fim: moment(
            ordersState[ordersState.tableType || EOrderTab.OPEN]
              .initialInputValues.endDate
          ).format('DD/MM/YYYY')
        })
      );
      return;
    }

    const billingsFromBilling = order?.billing?.filter(
      (item: Billing) => item.danfeNumber === danfeNumber
    );

    const billings: Billing[] = billingsFromBilling?.length
      ? billingsFromBilling
      : ([
          { danfeNumber, invoiceNumber: order?.invoiceNumber }
        ] as unknown as Billing[]);

    dispatch(
      loadNewNFFile({
        billings
      })
    );

    dispatch(
      sendTagging({
        event: 'baixar_nota_fiscal',
        pedido_id: order.customerOrder,
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.startDate
        ).format('DD/MM/YYYY'),
        data_fim: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.endDate
        ).format('DD/MM/YYYY')
      })
    );
  };

  const downloadCQ = (cqNumber?: string) => {
    if (!cqNumber) {
      dispatch(loadNewQCFile([order]));

      dispatch(
        sendTagging({
          event: 'baixar_todos_certificados',
          pedido_id: order.customerOrder,
          screenName: 'LG:MeusPedidos',
          itemDescription: 'meus_pedidos_acosLongos',
          estado_emissor:
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.states.join(', '),
          emissor_pedido: customersState.customers
            .filter((item) =>
              ordersState[
                ordersState.tableType || EOrderTab.OPEN
              ].initialInputValues.emitterIds.includes(item.customerId)
            )
            .map((item) => item.name)
            .join(', '),
          data_inicio: moment(
            ordersState[ordersState.tableType || EOrderTab.OPEN]
              .initialInputValues.startDate
          ).format('DD/MM/YYYY'),
          data_fim: moment(
            ordersState[ordersState.tableType || EOrderTab.OPEN]
              .initialInputValues.endDate
          ).format('DD/MM/YYYY')
        })
      );
      return;
    }

    dispatch(
      loadNewQCFile([
        {
          ...order,
          billing: order?.billing?.filter((item) => item.cqNumber === cqNumber)
        }
      ])
    );

    dispatch(
      sendTagging({
        event: 'baixar_certificado',
        pedido_id: order.customerOrder,
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.startDate
        ).format('DD/MM/YYYY'),
        data_fim: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.endDate
        ).format('DD/MM/YYYY')
      })
    );
  };

  const downloadShippingNote = (ref: string) => {
    const matchedBilling = order?.billing?.filter(
      (item) => item.invoiceZvoi === ref || item.deliveryDocumentZvoi === ref
    );
    dispatch(
      loadNewShippingNoteFile([
        matchedBilling?.length ? { ...order, billing: matchedBilling } : order
      ])
    );
  };

  return (
    <Container>
      <SideSheet openFromSide="right" onClose={handleClose} isOpen={!!data}>
        <SideSheetContainer>
          <HeaderContainer>
            <Title>{order?.sku ?? order?.billingHistory?.sku}</Title>
            <Text>
              {order?.materialDescription ??
                order?.billingHistory?.materialDescription}
            </Text>
            {order?.futureDeliveries && order?.futureDeliveriesTable && (
              <DeliveryStatusColumn data={order.futureDeliveriesTable} />
            )}
          </HeaderContainer>
          <SectionContainer>
            {(order?.billing?.some((item) => item.canDownloadQC) ||
              order?.billingHistory?.canDownloadQC) && (
              <SectionContent>
                <Title>Certificados de qualidade</Title>
                {order?.billing?.map(
                  (item) =>
                    item.cqNumber && (
                      <SectionWrapper key={item.cqNumber}>
                        <DownloadText onClick={() => downloadCQ(item.cqNumber)}>
                          Baixar {item.cqNumber}
                        </DownloadText>
                      </SectionWrapper>
                    )
                )}
                {order?.cqNumber && (
                  <SectionWrapper key={order?.cqNumber}>
                    <DownloadText onClick={() => downloadCQ(order?.cqNumber)}>
                      Baixar {order?.cqNumber}
                    </DownloadText>
                  </SectionWrapper>
                )}
              </SectionContent>
            )}

            {(order?.billing?.some((item) => item.canDownloadNF) ||
              order?.billingHistory?.canDownloadNF) && (
              <SectionContent>
                <Title>Notas fiscais</Title>
                {order?.billing?.map(
                  (item: Billing) =>
                    item?.danfeNumber && (
                      <SectionWrapper key={item?.danfeNumber}>
                        <DownloadText
                          onClick={() => downloadNFE(item.danfeNumber)}
                        >
                          Baixar {item.invoiceNumber || item.danfeNumber}
                        </DownloadText>
                      </SectionWrapper>
                    )
                )}
                {order?.danfeNumber && (
                  <SectionWrapper key={order?.danfeNumber}>
                    <DownloadText
                      onClick={() => downloadNFE(order?.danfeNumber)}
                    >
                      Baixar {order?.invoiceNumber || order?.danfeNumber}
                    </DownloadText>
                  </SectionWrapper>
                )}
              </SectionContent>
            )}

            {(order?.billing?.some((item) => item.invoiceZvoi) ||
              !!order?.deliveryDocumentZvoi) && (
              <SectionContent>
                <Title>Notas de remessas</Title>
                {order?.billing?.some((item) => item.invoiceZvoi)
                  ? order.billing.map(
                      (item) =>
                        item?.invoiceZvoi && (
                          <SectionWrapper key={item.invoiceZvoi}>
                            <DownloadText
                              onClick={() =>
                                downloadShippingNote(item.invoiceZvoi)
                              }
                            >
                              Baixar {item.invoiceZvoi}
                            </DownloadText>
                          </SectionWrapper>
                        )
                    )
                  : order?.deliveryDocumentZvoi && (
                      <SectionWrapper key={order.deliveryDocumentZvoi}>
                        <DownloadText
                          onClick={() =>
                            downloadShippingNote(
                              order.deliveryDocumentZvoi ?? ''
                            )
                          }
                        >
                          Baixar{' '}
                          {order?.invoiceZvoi || order?.deliveryDocumentZvoi}
                        </DownloadText>
                      </SectionWrapper>
                    )}
              </SectionContent>
            )}

            <SectionContent>
              <Title>Dados do produto</Title>
              <ProductTable>
                <TextTable>Identificação do pedido</TextTable>
                <TextTable>{order?.customerOrder}</TextTable>
                <TextTable>Número da OV</TextTable>
                <TextTable>{order.salesOrder}</TextTable>
                <TextTable>Quantidade solicitada</TextTable>
                <TextTable>
                  {order?.quantities?.requestedQuantity}{' '}
                  {order?.quantities?.requestedMeasureUnit}
                </TextTable>
              </ProductTable>
            </SectionContent>
          </SectionContainer>
        </SideSheetContainer>
      </SideSheet>
    </Container>
  );
};
